const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/Forms/actions.ts';
import { KisApiAction, kisapiActionTypes } from '../../defs/actionTypes';
import { KISAPI as API } from '../../middleware/kisapi';
import { apiLoadMetaKatBlock } from '@cistec/common_web/actions/kisapi/metaKat';
import { apiSearchUsers } from '@cistec/common_web/actions/kisapi/users';

export const LOAD_FROM_METAKAT_FOR_FORM = kisapiActionTypes('LOAD_FROM_METAKAT_FOR_FORM');

export function actionLoadMetaKatBlockForForm(pcode: string, lookup = false) {
    return {
        type: LOAD_FROM_METAKAT_FOR_FORM.combined,
        [API]: apiLoadMetaKatBlock(
            pcode,
            ['ICODE', 'PCODE', 'KAT', 'FKEY', 'NAME', 'TYP', 'STATUS', 'CONTENT'],
            lookup
        ),
        meta: {
            pcode,
            lookup,
        },
    };
}

export type LoadMetaKatChildrenForFormAction = KisApiAction<typeof actionLoadMetaKatBlockForForm>;

export const SEARCH_USER_FOR_FORM = kisapiActionTypes('SEARCH_USER_FOR_FORM');

export function actionSearchUserForForm(
    contextId: string,
    searchText: string,
    filterByZUSUSRSEL: boolean = false,
    filterByOcode: string | boolean = false,
    filterByFunKey: string | boolean = false
) {
    return {
        type: SEARCH_USER_FOR_FORM.combined,
        [API]: apiSearchUsers(searchText, filterByOcode, filterByFunKey, filterByZUSUSRSEL),
        meta: {
            contextId,
            searchText,
        },
    };
}

export type SearchUserForFormAction = KisApiAction<typeof actionSearchUserForForm>;

export const CLEAR_SEARCH_USER_FOR_FORM = 'CLEAR_SEARCH_USER_FOR_FORM';

export function actionClearSearchUserForForm(contextId: string) {
    return {
        type: CLEAR_SEARCH_USER_FOR_FORM,
        meta: {
            contextId,
        },
    };
}

export type ClearSearchUserForFormAction = KisApiAction<typeof actionClearSearchUserForForm>;
